import React from 'react';

import { certificatesActions, modalState } from '../../../redux/reducers/certificates';
import { useAppSelector, useAppDispatch } from '../../../hooks/useRedux';
import SessionOutdated from '../../../pages/common/SessionOutdated';

import UploadCSR from './UploadCSR';
import RevokeCSR from './RevokeCSR';

function ModalsContainer(props) {
  const dispatch = useAppDispatch();
  const activeModal = useAppSelector(modalState);

  function renderModal() {
    switch (activeModal.name) {
      case 'upload CSR file':
        return <UploadCSR closeModal={() => dispatch(certificatesActions.setActiveModalDetails({}))} />;
      case 'revoke CSR file':
        return <RevokeCSR closeModal={() => dispatch(certificatesActions.setActiveModalDetails({}))} />;
      case 'show session outdata popup':
        return (
          <SessionOutdated
            visibility
            hide={() => dispatch(certificatesActions.setActiveModalDetails({}))}
          />
        );
      default:
        return null;
    }
  }

  return renderModal();
}

export default ModalsContainer;
